export default __webpack_public_path__ + "static/media/happy_face.95484be5.svg";